<template>
  <base-nav
    v-model="showMenu"
    class="navbar-absolute top-navbar"
    type="success"
    :transparent="true"
    style="border: none"
  >
    <div slot="brand" class="navbar-wrapper" id="time">
      <div class="navbar-minimize d-inline">
        <!-- <img src="@/assets/img/Nex.Us Logo-black.png" width="120"/> -->
        <sidebar-toggle-button v-if="roleid != 5" />
      </div>
      <div
        class="navbar-toggle d-inline"
        :class="{ toggled: $sidebar.showSidebar }"
      >
        <button type="button" class="navbar-toggler" @click="toggleSidebar">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
      <div class="column">
        <div class="col-lg text-left">
          <!-- comment: should be userName -->
          <a
            class="navbar-brand"
            href="#pablo"
            style="
              color: #358CCB;
              font-weight: 500;
              text-transform: capitalize;
              font-size: 25px;
            "
          >
            {{ routeName }}</a
          >
          <p
            style="
              color: #b9b9b9;
              font-size: 13px;
              margin-top: -10px;
              padding-left: 18px;
            "
          >
            <!-- {{ $t("sidebar.datalastupdate") }}  minute ago -->
            Data last update {{ lastupdate }}
          </p>
        </div>
      </div>
    </div>

    <ul class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
      <div class="row">
        <base-dropdown
          tag="li"
          :menu-on-right="!$rtl.isRTL"
          title-tag="a"
          title-classes="nav-link"
          class="nav-item"
        >
          <template slot="title">
            <div></div>
            <!-- <base-button class="btn-primary btn-icon btn-round"
              ><img
                style="
                  position: absolute;
                  background-color: #358CCB;
                  border: 2px solid #358CCB;
                  border-radius: 20px;
                  padding: 8px;
                "
                src="img/bell.png"
                width="37px"
            /></base-button> -->
          </template>
          <p
            style="
              color: black;
              font-weight: 600;
              font-size: 14px;
              padding-left: 10px;
            "
          >
            Notifications
          </p>

          <!-- <li class="nav-link" v-for="item in notifications" :key="item.id">
            <a
              href="#"
              class="nav-item dropdown-item"
              style="disply: inline"
              @click="locate(item)"
            >
              <a style="color: #358CCB; disply: inline; font-weight: bold"
                >{{ item.alertname }} </a
              ><br />{{ item.alertreportedat }}
            </a>
          </li> -->
          <li class="nav-link" v-for="item in notifications" :key="item.id">
            <a
              href="#"
              class="nav-item dropdown-item"
              style="display: inline"
              @click="locate(item)"
            >
              <a style="color: black; display: inline; font-weight: bold"
                >New job request </a
              ><br />Now
            </a>
          </li>
          <li class="nav-link" v-for="item in notifications" :key="item.id">
            <a
              href="#"
              class="nav-item dropdown-item"
              style="display: inline"
              @click="locate(item)"
            >
              <a style="color: black; display: inline; font-weight: bold"
                >Firmware Updated </a
              ><br />24 July 2022 | 12:30pm
            </a>
          </li>
          <el-divider> </el-divider>
          <li>
            <a
              @click="goToNotification()"
              href="#"
              class="nav-item dropdown-item"
              style="text-align: center; margin-top: -12px"
              >Mark all as read</a
            >
          </li>
        </base-dropdown>
        <!-- </base-dropdown> -->

        <base-dropdown
          tag="li"
          :menu-on-right="!$rtl.isRTL"
          title-tag="a"
          class="nav-item"
          title-classes="nav-link"
          menu-classes="dropdown-navbar"
        >
          <!-- menu-on-right=""
              tag="div"
              title-classes="btn btn-link btn-icon"
              :class="{ 'float-left': $rtl.isRTL }" -->

          <base-button
            slot="title"
            class="btn-round btn-white"
            style="background-color: white"
            ><img
              style="
                position: absolute;
                left: 5px;
                border: 2px solid #358CCB;
                border-radius: 20px;
              "
              src="img/alam-flora-sq.png"
              width="37px" />

            <span class="text" style="font-weight: normal">
              &nbsp;&nbsp;&nbsp;{{ role }}</span
            ><i
              style="color: #707070; position: absolute; right: 12px; top: 7px"
              class="fa fa-sort-down"
              aria-hidden="true"
            ></i
          ></base-button>
          <a class="dropdown-item" @click="gotoprofile()"
            ><i class="fa fa-user" aria-hidden="true"></i>Profile</a
          >
          <a
            class="dropdown-item"
            @click="gotosetting()"
            v-if="positionid == 1 || positionid == 2"
            ><i class="fa fa-cog" aria-hidden="true"></i>Settings</a
          >
          <a class="dropdown-item" @click="logout()"
            ><i class="fa fa-sign-out-alt"></i>Sign out</a
          >

          <!-- <template slot="title">
          <div></div>
          <div class="photo">
            <img src="img/default-avatar.png" />
          </div>
          <b class="caret d-none d-lg-block d-xl-block"></b>
          <p class="d-lg-none">Log out</p>
        </template>

        <li class="nav-link">
          <a class="nav-item dropdown-item" @click="logout()">Log out</a>
        </li> -->
        </base-dropdown>
      </div>
    </ul>
  </base-nav>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import { BaseNav, Modal } from "@/components";
import SidebarToggleButton from "./SidebarToggleButton";
import { Divider } from "element-ui";
import swal from "sweetalert2";
import util from "../../util/util";
import moment from "moment";

export default {
  components: {
    SidebarToggleButton,
    CollapseTransition,
    BaseNav,
    Modal,
    [Divider.name]: Divider,
  },
  computed: {
    routeName() {
      console.log(this.$route);
      const { name } = this.$route;
      console.log(name);
      let navbarTitle = "";
      navbarTitle = name;
      if (name == "Home") {
        navbarTitle = this.$t("sidebar.overview");
      }
      if (name == "Incoming" || name == "Job Page") {
        navbarTitle = this.$t("Incoming");
      }

      if (name == "Pre-Processing") {
        navbarTitle = "Pre-Processing";
      }

      if (
        name == "LandOverview" ||
        name == "VesselOverview" ||
        name == "VendorOverview" ||
        name == "AuthoritiesOverview"
      ) {
        navbarTitle = this.$t("Overview");
      }
      if (
        name == "LandRequest" ||
        name == "LandRequestJob" ||
        name == "LandReview" ||
        name == "VesselRequest" ||
        name == "VesselRequestJob" ||
        name == "VesselReview"
      ) {
        navbarTitle = this.$t("Waste Disposal Request");
      }
      if (name == "LandCalendar" || name == "VesselCalendar") {
        navbarTitle = this.$t("Waste Disposal Calendar");
      }
      if (name == "Pre-processing") {
        navbarTitle = this.$t("Pre-processing");
      }
      if (name == "Inventory Overview") {
        navbarTitle = this.$t("Inventory");
      }
      if (
        name == "Outgoing" ||
        name == "Job" ||
        name == "VendorJob" ||
        name == "AuthoritiesJob"
      ) {
        navbarTitle = this.$t("Outgoing");
      }
      if (name == "VendorJobPage") {
        navbarTitle = this.$t("Outgoing Job");
      }
      if (
        name == "User Management" ||
        name == "New User Registration" ||
        name == "New Contractor Registration"
      ) {
        navbarTitle = this.$t("User Management");
      }
      if (
        name == "Calendar" ||
        name == "VendorSchedule" ||
        name == "AuthoritiesSchedule"
      ) {
        navbarTitle = this.$t("Calendar");
      }
      if (name == "Forms" || name == "LandForm" || name == "VesselForm") {
        navbarTitle = this.$t("Internal Documents");
      }
      if (name == "Reports") {
        navbarTitle = this.$t("Reports");
      }
      if (name == "Edit Page") {
        navbarTitle = this.$t("Edit");
      }
      if (name == "Sales") {
        navbarTitle = this.$t("Sales");
      }

      return this.capitalizeFirstLetter(navbarTitle);
    },
    isRTL() {
      return this.$rtl.isRTL;
    },
  },
  data() {
    return {
      roleid: "",
      lastupdate: "",
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: "",
      empName: "",
      notifications: [
        {
          alertname: "",
          alertreportedat: "",
        },
      ],
      customerid: "",
      plants: [],
      email: "",
      role: "",
      positionid: "",
    };
  },

  mounted() {
    // this.role = sessionStorage.getItem("role-name");
    this.role = JSON.parse(
      atob(sessionStorage.getItem("token").split(".")[1])
    ).username;
    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );
    console.log(this.positionid);
  },
  created() {
    this.roleid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1])).role_id
    );
    let timenow = moment();
    this.getLastUpdate(timenow);
    this.refreshrate2 = setInterval(() => {
      this.getLastUpdate(timenow);
    }, 10000);

    // let jwtToken = JSON.parse(
    //   atob(sessionStorage.getItem("token").split(".")[1])
    // );
    // this.email = jwtToken.Email;
    // this.empName = jwtToken.FirstName;
    // this.customerid = jwtToken.UserID;
    // this.getNotifications();
  },
  destroyed() {
    clearInterval(this.refreshrate2);
  },
  methods: {
    gotoprofile() {
      this.$router.push("/profile");
    },
    getLastUpdate(time) {
      this.lastupdate = moment(time).fromNow();
    },
    gotosetting() {
      this.$router.push("/setting");
    },
    // goToNotification() {
    //   this.$router.push("/notification");
    // },
    // getNotifications() {
    //   this.notifications = [];

    //   this.$http.get("/solar/api/v1/notification").then((res) => {
    //     if (!res.error) {
    //       let response = res.message;

    //       for (var i = 0; i < 3; i++) {
    //         let date = moment(
    //           response[i].AlertReportedAt,
    //           "hh:mma DD MMM YYYY"
    //         ).format("YYYY-MM-DD");

    //         let obj = {
    //           id: i,
    //           alertname: response[i].AlertName,
    //           alertreportedat: date,
    //         };

    //         this.notifications.push(obj);
    //       }
    //     }
    //   });
    // },
    logout() {
      // this.$http
      //   .put("/sso/auth/logout/" + this.email)
      //   .then((res) => {
      //     if (!res.error) {
      //       util.stopPing();
      //       sessionStorage.removeItem("token", res.message.jwt_token);
      //       this.$router.push("/login");
      //     } else {
      sessionStorage.removeItem("collectiondate");
      sessionStorage.removeItem("datasubmitted");
      sessionStorage.removeItem("remember");
      sessionStorage.removeItem("email-login");
      sessionStorage.removeItem("role-name");
      sessionStorage.removeItem("rememberme");
      sessionStorage.removeItem("passwordremember");
      // sessionStorage.removeItem("rememberme");
      localStorage.removeItem("token");
      sessionStorage.removeItem("token");
      this.$cookies.remove("token");

      this.$router.push("/login");
      //   }
      // })
      // .catch((err) => {
      //   console.log(err);
      // });
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
  },
};
</script>
<style scoped>
.top-navbar {
  top: 0px;
}
hr {
  margin-top: 2%;
  margin-bottom: 0%;
}
.avatar-name {
  margin-top: 7%;
}
</style>
